module.exports = __webpack_public_path__ + "static/media/logo-buhler-new.a9e1a5b1.svg";